import { Platform } from 'react-native';
import { APITypes } from '../../../../../primary-record-types';
import { Environment, useEnvironment } from '../../../../../hooks/useEnvironment';

const getBaseUrl = (env: Environment, shareCode: string) => {
    const path = `/shared-report?shareCode=${shareCode}`;
    if (Platform.OS === 'web') {
        return window.location.origin + path;
    } else {
        return (env === 'dev' ? 'https://dev.primaryrecord.app' : `https://www.primaryrecord.app`) + path;
    }
};

export const useSharedReportUrl = (sharedReport: APITypes.reportService.SharedReportItem | null): string | null => {
    const environment = useEnvironment();
    if (environment === 'loading' || !sharedReport || !sharedReport.shareCode) return null;

    return getBaseUrl(environment, sharedReport.shareCode);
};
